<template>
<div>

<!-- torneio normais
<div v-for="tor in torneio" v-if="tor.tipo != 4">
    <div class="col-md-12">
        <div class="card text_branco mb-3" v-bind:class="[tipo==1?'card_roxo':tipo==2?'card_verde':'card_laranja']">
          <div class="row">
            <div class="col-6">
                <div class="text_17 text_bold" v-bind:class="[tipo==1?'text_roxo':tipo==2?'text_verde':'text_laranja']">
                  {{tor.nome}}
                </div>

                <div class="text_12 text_branco">{{tor.descricao_pagamento}}</div>

                <div>
                    <div style="float:left; padding-right:0; padding-right:10px;">
                        <div class="text_16 text_cinza mt-1">{{tor.qtd_aposta}}/{{tor.max_pessoa}}</div>
                        <div class="text_10 text_cinza mb-1">Participantes/Max</div>
                    </div>
                    <div style="float:left; padding-right:0; padding-right:10px;">
                        <div class="text_cinza text_16 mt-1">{{tor.qtd_mercado_obrigatorio}}</div>
                        <div class="text_cinza text_10">Palpites</div>
                    </div>
                    <div style="float:left; padding-right:0;">
                        <div class="text_cinza text_16 mt-1">{{tor.max_reentrada - 1}}</div>
                        <div class="text_cinza text_10 mb-2">Reentradas</div>
                    </div>
                </div>
            </div>

            <div class="col-6">
              <div class="text_13" v-show="tipo != 3" v-bind:class="[tipo==1?'text_roxo':tipo==2?'text_verde':'text_laranja']">1º Prémio equivale uma odd @{{formatarMoeda(tor.odd)}}</div>
              <div class="text_amarelo text_12">
                Começa em: <span class="text_bold">{{tor.time_regressivo}}</span>
              </div>
              <div class="text_cinza text_12">Previsão de Término: {{timestamp_dataBR(tor.dt_termino_timestamp,3)}}</div>
              <router-link :to="{name:'torneio_detalhes', params:{torneio_id:tor.id,page_back:0} }"
              class="card text-center text_10 mt-1 w-100" v-bind:class="[tipo==1?'btn_roxo':tipo==2?'btn_verde':'btn_laranja']">
              <b>VER JOGOS |
                <span v-if="[1, 2].includes(tipo)">R$ {{tor.taxa_entrada}}</span>
                <span v-if="tipo == 3">GRÁTIS</span>
              </b>
              </router-link>
            </div>
          </div>
        </div>
    </div>
</div>
-->

<!-- torneio normais  -->
<div v-for="(tor, index) in torneio" v-if="tor.dif > 0 && tor.tipo != 4">
    <div class="col-md-12">
        <div class="card text_branco mb-3" v-bind:class="[tipo==1?'card_roxo':tipo==2?'card_verde':'card_laranja']">
          <div class="row">
            <div class="col-6">
                <div class="text_17 text_bold" v-bind:class="[tipo==1?'text_roxo':tipo==2?'text_verde':'text_laranja']">
                  {{tor.nome}}
                </div>

                <div class="text_12 text_branco">{{tor.descricao_pagamento}}</div>

                <div>
                    <div style="float:left; padding-right:0; padding-right:10px;">
                        <div class="text_16 text_cinza mt-1">{{tor.qtd_aposta}}/{{tor.max_pessoa}}</div>
                        <div class="text_10 text_cinza mb-1">Participantes/Max</div>
                    </div>
                    <div style="float:left; padding-right:0; padding-right:10px;">
                        <div class="text_cinza text_16 mt-1">{{tor.qtd_mercado_obrigatorio}}</div>
                        <div class="text_cinza text_10">Palpites</div>
                    </div>
                    <div style="float:left; padding-right:0;">
                        <div class="text_cinza text_16 mt-1">{{tor.max_reentrada - 1}}</div>
                        <div class="text_cinza text_10 mb-2">Reentradas</div>
                    </div>
                </div>
            </div>

            <div class="col-6">
              <div class="text_13" v-show="tipo != 3" v-bind:class="[tipo==1?'text_roxo':tipo==2?'text_verde':'text_laranja']">1º Prémio equivale uma odd @{{formatarMoeda(tor.odd)}}</div>
              <div class="text_amarelo text_12">
                Começa em: <span class="text_bold">{{tor.time_regressivo}}</span>
              </div>
              <div class="text_cinza text_12">Previsão de Término: {{timestamp_dataBR(tor.dt_termino_timestamp,3)}}</div>
              <router-link :to="{name:'torneio_detalhes', params:{torneio_id:tor.id,page_back:0} }"
              class="card text-center text_10 mt-1 w-100" v-bind:class="[tipo==1?'btn_roxo':tipo==2?'btn_verde':'btn_laranja']">
              <b>VER JOGOS |
                <span v-if="[1, 2].includes(tipo)">R$ {{tor.taxa_entrada}}</span>
                <span v-if="tipo == 3">GRÁTIS</span>
              </b>
              </router-link>
            </div>
          </div>
        </div>
    </div>
</div>


</div>
</template>

<script>

import ccContagemRegressiva from '../cc_geral/cc_contagem_regressiva.vue'
import ccMensagem from '../cc_geral/mensagem.vue'
import ccAlert from '../cc_geral/cc_alert.vue'

export default {
  data () {
    return {
      //socket
      socket : {},
      canal : "canal_home",
      countSocket: 0,
      fala_servidor: null,
      fonte: null,

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors:[],

      //array
      original: [],
      torneio: [],
      tipo: 0,
      destaque : 0,
    }
  },

  components: {ccContagemRegressiva, ccMensagem, ccAlert},

  mounted(){
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    this.start_time()
  },

  methods: {

      receber_dados(tipo, response, destaque){
        this.tipo = tipo
        this.destaque = destaque
        this.original = response
        this.higienizar()
      },

      /*
      higienizar(){
        let agora = Date.now()
        let a = this.original

        var obj = {}
        this.torneio = []

        let dif = 0;

        for (var i=0; i <= a.length -1; i++)
        {
          if(a[i].qtd_aposta < a[i].max_pessoa && a[i].destaque == this.destaque) {
              dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
              dif = parseInt(dif/1000);

              if(dif > 0){
                obj = {
                  id :a[i].id,
                  nome :a[i].nome,
                  tipo_id :a[i].tipo_id,
                  sumario :a[i].sumario,
                  dt_inicio_timestamp :a[i].dt_inicio_timestamp,
                  descricao_pagamento :a[i].descricao_pagamento,
                  odd :a[i].odd,
                  taxa_entrada :a[i].taxa_entrada,
                  min_pessoa :a[i].min_pessoa,
                  max_pessoa :a[i].max_pessoa,
                  max_reentrada :a[i].max_reentrada,
                  qtd_aposta :a[i].qtd_aposta,
                  qtd_jogo :a[i].qtd_jogo,
                  qtd_mercado_obrigatorio :a[i].qtd_mercado_obrigatorio,
                  prize :a[i].prize,
                  status :a[i].status,
                  status_nome :a[i].status_nome,
                  destaque :a[i].destaque,
                  jogo: a[i].jogo,
                  dt_termino_timestamp: a[i].dt_termino_timestamp,
                  dif: dif,
                  time_regressivo: 999,
                }
              }

              this.torneio.push(obj);
          }
        }

        //get o menor em tempos
        let aux_menor = 9999999999999
        for (var i=0; i <= this.torneio.length -1; i++) {
          if(this.torneio[i].destaque == 0 && this.torneio[i].dif <= aux_menor ){
            aux_menor = this.torneio[i].dif
          }
        }

      },
      */

       higienizar(){
        let agora = Date.now()
        let a = this.original

        var obj = {}
        this.torneio = []

        let dif = 0;

        for (var i=0; i <= a.length -1; i++)
        {
          if(a[i].qtd_aposta < a[i].max_pessoa && a[i].destaque == this.destaque) {
              dif = ( (a[i].dt_inicio_timestamp * 1000) - agora )
              dif = parseInt(dif/1000);

              if(dif > 0){
                obj = {
                  id :a[i].id,
                  nome :a[i].nome,
                  tipo_id :a[i].tipo_id,
                  sumario :a[i].sumario,
                  dt_inicio_timestamp :a[i].dt_inicio_timestamp,
                  descricao_pagamento :a[i].descricao_pagamento,
                  odd :a[i].odd,
                  taxa_entrada :a[i].taxa_entrada,
                  min_pessoa :a[i].min_pessoa,
                  max_pessoa :a[i].max_pessoa,
                  max_reentrada :a[i].max_reentrada,
                  qtd_aposta :a[i].qtd_aposta,
                  qtd_jogo :a[i].qtd_jogo,
                  qtd_mercado_obrigatorio :a[i].qtd_mercado_obrigatorio,
                  prize :a[i].prize,
                  status :a[i].status,
                  status_nome :a[i].status_nome,
                  destaque :a[i].destaque,
                  jogo: a[i].jogo,
                  dt_termino_timestamp: a[i].dt_termino_timestamp,
                  dif: dif,
                  time_regressivo: this.timestamp_horas_minutos_segundos(dif),
                }
              }

              this.torneio.push(obj);
          }
        }

        //get o menor em tempos
        let aux_menor = 9999999999999
        for (var i=0; i <= this.torneio.length -1; i++) {
          if(this.torneio[i].destaque == 0 && this.torneio[i].dif <= aux_menor ){
            aux_menor = this.torneio[i].dif
          }
        }
      },



      start_time(){
        this.timer_torneio_horario = setInterval( function(){

          for (var i=0; i < this.torneio.length; i++){
            this.torneio[i].dif = this.torneio[i].dif - 1;
            this.torneio[i].time_regressivo = this.timestamp_horas_minutos_segundos( this.torneio[i].dif )
          }

        }.bind(this), 1000);
      },

  },

}
</script>


// WEBPACK FOOTER //
// src/components/home/home_cc_card.vue